import MainFilters from "./MainFilters";
import OpenFilters from "./OpenFilters";
import OpenSearch from "./OpenSearch";
import { Group } from "./styles";

export type MainViewProps = {
  openFilters: () => void;
  openSearch: () => void;
};

const MainView: React.FC<MainViewProps> = (props) => {
  const { openFilters, openSearch } = props;
  return (
    <>
      <Group>
        <MainFilters />
      </Group>
      <Group>
        <OpenFilters handleOpen={() => openFilters()} />
        <OpenSearch handleOpen={() => openSearch()} />
      </Group>
    </>
  );
};

export default MainView;
